module.exports = __webpack_public_path__ + "media/post-listing-block-5-overlay.7f389a26.webp";